export default {
  commonMsg: {
    back: "Return",
    save: "Save",
    del: "Delete",
    destroy: "Destroy",
    add: "Add",
    handle: "Operate",
    No: "No",
    new: "Newly added",
    edit: "Edit",
    replace: "Replace",
    confirm: "Confirm",
    check: "Check",
    cancel: "Cancel",
    checkDetails: "View details",
    checkAll: "All election",
    sort: "Sort",
    none: "No",
    rename: "Rename",
    author: "Author",
    status: "Status",
    search: "Search",
    manage: "Administration",
    release: "Release",
    admin: "Administrator",
    logout: "Sign Out",
    move: "Move",
    remove: "Remove",
    create: "Establesh",
    address: "Address",
    preview: "Preview",
    upload: "Upload",
    next: "Next page",
    prev: "Last page",
    failure: "Failure",
    success: "Success",
    uploading: "Uploading",
    pending: "Pending",
    tips: "Tips",
    correction: "correction",
    recovery: "recovery",
    downLoadForecast: "Download template",
    updatedAt: "Updated Time",
    createdAt: "Creation Time",
    export: "Export",
    startAt: "开始时间",
    endAt: "结束时间",
    date: "Date",
  },
  alertMsg: {
    success: "Success",
    fail: "Fail",
    switchSuccess: "Switchover successfully",
    soldOutSuccess: "Sold out successfully",
    soldOnSuccess: "上架成功",
    addSuccess: "Add successfully",
    addFailure: "Add failed",
    unlockSuccess: "Deblock device successfully",
    saveSuccess: "Save successfully",
    saveFailure: "Save failed",
    editSuccess: "Edit successfully",
    editFailure: "Edit failed",
    moveSuccess: "Move successfully",
    moveFailure: "Move failed",
    uploadSuccess: "Upload successfully",
    uploadFailure: "Upload failed",
    modifySuccess: "Modify successfully",
    modifyFailure: "Modify failed",
    delSuccess: "Delete successfully",
    delFailure: "Delete failed",
    releaseSuccess: "Release successfully",
    Unpublished: "Unpublished",
    releaseFailure: "Release failed",
    sortFailure: "Sort failed",
    sortErr1: "Cannot sort outer book list",
    sortErr2: "Cannot sort across the outer list",
    releaseChannel: "Please select publishing channel",
    checkBook: "Please check the book first",
    uploadSize: "Upload file size cannot exceed 100MB!",
    uploadFormat:
      "Upload file can only be APK,EPUB,PDF,XLSX,XLS,DOC,DOCX,PPT,PPTX format!",
    removeTip: "Confirm removal",
    selectTag: "Please select a label",
    uploadTip:
      "Please upload the file or wait for the file to be uploaded before saving",
    userRole: "Please fill in the role",
    delConfirm: "Confirm resource deletion",
    delTitle: "Delete window",
    unlockConfirm: "Confirm to unbind the device ?",
    unlockTitle: "Unbinding device pop-up window",
    addList: "Add list popup",
    addGroup: "Add book list",
    refreshGroup: "update book list",
    publicSuccess: " Published successfully",
    recoverySuccess: " Recycling successful",
    existTitle: "The title already exists",
    existWord: "The word already exists",
  },
  placeholder: {
    name: "Please enter a name ",
    select: "Please select ",
    enter: "Please input",
    bookName: "Please input book name (4-20 words)",
    date: "Please select date",
    checkKey: "Keyword search",
    orgName: "Please input organization name",
    area: "Please input region",
    address: "Please input address",
    tagName: "Please input label name",
    role: "Please select role",
    dateTime: "Please select date and time",
  },
  // 路由
  router: {
    internalDevice: "研发样机管理",
    deviceActivation: "Device activation",
    content: "Content management",
    orders: "Order management",
    bookstore: "书城管理",
    vnBookstore: "越南书城",
    iGetBookstore: "得到书城",
    twBookstore: "台湾书城",
    book: "Book management",
    group: "Book list",
    store: "Foreground bookstore",
    org: "Organizational management",
    orgList: "List of institutions",
    orgTag: "institutional label",
    storeConfig: "book city configuration",
    screenConfig: "On off screen protection configuration",
    users: "User management",
    roles: "Privilege managment",
    permissionModules: "Module management",
    userRole: "用户账号权限",
    device: "Device management",
    smsWhitelist: "SMS whitelist",
    noteLabDeviceConfig: "Note Lab Device Config",
    upgrade: "Firmware upgrade management",
    update: "Version update",
    statistics: "Date statistics",
    use: "Usage statistics",
    pcStats: "PC statistics",
    bookApp: "Book city application statistics",
    ranking: "Ranking List",
    booxCloud: "云盘相关统计",
    notesInfo: "云盘概况统计",
    libraryStats: "书库相关统计",
    market: "销售相关",
    operation: "Operations",
    sales: "Sales",
    coupon: "优惠券",
    advertisement: "广告",
    order: "订单",
    poetry: "诗词管理",
    dictionary: "单词字典",
    screensaver: "屏保管理",
    writeTemplate: "笔记背景图",
    urlParse: "网页解析规则",
    lang: "语言标签管理",
    devicesPower: "设备用电信息管理",
    devicesModelTag: "设备型号标签管理",
    devicesModel: "型号管理",
    staticBook: "预装书",
    motto: "格言管理",
    feedback: "信息反馈",
    feedbackInfo: "CB信息反馈",
    setting: "后台设置",
    gift: "活动管理",
    boox: "BOOX助手",
    booxApp: "软件更新",
    booxAdv: "助手广告",
    booxVersions: "版本管理",
    updateList: "更新记录",
    updatePublish: "发布版本",
    updateTest: "内测版本",
    updateApply: "申请内测",
    updateAdd: "新增",
    updateView: "详情",
    thank: "特别致谢",
    cookieContent: "cookie内容管理",
    serverMGT: "服务器管理",
    searchSite: "搜索站点管理",
    add: "新增",
    edit: "编辑",
    card: "卡片管理",
    introduction: "介绍说明",
    faq: "FAQ",
    screen: "投屏说明",
    privacy: "隐私政策",
    deviceInfo: "设备统计",
    usePowers: "权限使用情况",
    manual: "用户手册",
    couchbase: "Couchbase统计",
    feedbackTag: "反馈标签",
    sysNotice: "系统通知",
    loginAds: "网页端登录广告",
    rss: "RSS订阅",
    opds: "OPDS",
    wechatProduct: "微信硬件产品号管理",
    wechatIot: "微信硬件绑定用户统计",
    appConfManagement: "App Config Management",
    appConf: "Public Configs",
    appOptimization: "App Optimization",
    godCode: "God Code",
    appConfTag: "App Config Tags",
    appConfGroup: "App Config Groups",
    serviceConfig: "服务配置管理",
    thirdParty: "第三方服务配置",
    booxClient: "PC端版本管理",
    ddosWarning: "DDOS预警配置",
    accessBlack: "接口请求屏蔽配置",
    testGroup: "测试组管理",
    permissionStat: "权限统计",
    systemConfig: "系统配置",
    chatGPT: "chatGPT统计",
    integratedData: "综合数据面板",
    gptContent: "GPT提示语管理",
    adminConfig: "配置",
    bookstoreStatic: "书城流量统计",
    ossStats: "oss统计",
  },
  // 登录
  login: {
    title: "Content management platform",
    account: "User name /Mobile number/E-mail",
    password: "Password",
    auto: "Automatic logon",
    forget: "Forget password",
    logIn: "Log in",
    find: "Retrieve password",
    email: "Email",
    send: "Send",
    tip: "Please go to the email and click the link to change the password",
  },
  // 验证
  verify: {
    user: "Please enter user",
    password: "Please enter password",
    email: "Please enter email",
    groupName: "Name cannot be empty",
    name: "Please enter the name",
    bookName: "Please enter the book name",
    addClassify: "Please select a category to add",
    authorName: "Please enter the author name",
    price: "Please enter the price",
    bookDescription: "Please enter a book introduction",
    cover: "Please upload a cover",
    condition: "Please choose the shelf",
    orgName: "Institution name cannot be empty",
    orgAddress: "Address cannot be empty",
    orgId: "Please enter the agency code",
    orgArea: "Region cannot be empty",
    num: "Can only enter pure numbers",
    tag: "Label cannot be empty",
    orgExist: "Institutional code already exists",
    userRole: "Please select roles",
    phone: "Please enter the phone number",
    userName: "Please fill in the login name",
    userNameExist: "Login name already exists",
    firmwareModel: "Please enter the firmware model",
    firmwareBrand: "Please enter the firmware brand",
    firmwareVersion: "Please enter the firmware version",
    firmwareType: "Please enter the firmware type",
    firmwareLang: "Please enter the firmware language",
    firmwareMD5: "Please enter the firmware MD5",
    firmwareScrnW: "Please enter the firmware screen width",
    firmwareScrnH: "Please enter the firmware screen height",
    firmwareFingerprint: "Please enter the firmware fingerprint information",
    firmwareDownload: "Please enter the firmware download address",
  },
  // 内容管理
  content: {
    // 书籍管理
    books: {
      stack: "Book management",
      allBook: "All books",
      stackName: "Category name",
      editGroup: "Edit book list",
      addToGroup: "Add to the list",
      modifyGroup: "Modify book list",
      channelName: "Channel name",
      address: "跳转地址",
      groupName: "Book name",
      bookCount: "Number of books",
      onlineBook: "Online book",
      addBook: "Add books",
      pic: "Cover image",
      release: "Release channel",
      relate: "Associated institution",
      one: "1 star",
      two: "2 star",
      three: "3 star",
      four: "4 star",
      five: "5 star",
      online: "Online already",
      notOnline: "Not online",
      area_lang: "Region/Language",
      records: "Total record",
      cover: "Cover",
      bookName: "Book name",
      views: "Pageviews",
      sales: "Sales volume",
      readers: "Reader rating",
      price: "Price ",
      all: "The whole",
      classify: "Classification",
      group: "Book list",
      status: "Current state",
      cn: "Chinese simplified",
      tc: "Traditional Chinese",
      en: "English",
      inspirational: "Inspirational",
      literature: "Literature",
      technology: "Technology",
      biography: "Biography",
      score: "Score",
      bookDetails: "Book details",
      content: "Brief introduction",
      directory: "Table of Contents",
      author: "About the Author",
      comment: "Book review",
      allComment: "Book review",
      good: "Praise",
      normal: "Average",
      bad: "Negative comment",
      basic: "Basic information",
      chapter: "Chapter directory",
      chapterName: "Chapter name",
      addChapter: "Add chapter",
      addSection: "Add section",
      rename: "Modify name",
      addClassify: "Add category",
      editClassify: "Edit category",
      addChannel: "Add Channel",
      editChannel: "Edit Channel",
      priceTip:
        "Must be a number,such as :10(when entering 0,it will be displayed on the website: free)",
      picRemark:
        "Remark:wide 180px high 222px pictures is most suitable,the size should not exceed 50M",
      fileSize: "File size",
      fileFormat: "File format",
      count: "Word count",
      publisher: "Publishing house",
      publish_time: "Published date",
      edition: "Edition",
      bookDescription: "Book introduction ",
      condition: "Shelf situation",
      putaway: "Default shelf",
      notPutaway: "Default is not on the shelf",
      selectClassify: "Choose category",
      addGroup: "Join the list",
      selectGroup: "Selection list",
      setPrice: "Set price",
      soldOut: "下架",
      soldOn: "上架",
      hasComment: "Existing evaluation",
      name: "Name",
      moveClassify: "Move to the category",
      new: "Newest",
      top: "Best seller",
      addTo: "Add to ",
      publish: "Publish",
      boy: "Boy",
      girl: "Gril",
      uploadFile: "Upload files",
      selectFile: "Select file",
      uploadTip: "Can only upload one file and no more than 100MB",
      uploadServer: "Upload to server",
      createTip: "Please upload the file first ",
      releaseTo: "Post to",
      timingOn: "Timed shelves",
      shelfTime: "Please select the shelf time",
      showDevice: "设备显示",
      show: "显示",
      notShow: "不显示",
      batchUpload: "Bulk upload",
      batchUploadTips: "Please drag files here, or click the add file button",
      addFile: "Add file",
      startUpload: "Start upload",
    },
    // 前台书城
    store: {
      channel: "Channel management",
      banner: "Carousel map",
      frame: "Framework management",
      channelPreview: "Website preview channel",
      channelSelected: "Website selected channel",
      channelName: "Channel",
      channelOpen: "Open mode",
      bannerPreview: "Website preview carousel",
      bannerSelected: "Site optional carousel",
      addBanner: "Add a carousel",
      bannerTitle: "Carousel map",
      bannerName: "Name",
      bannerMove: "Move",
      bannerLink: "Connecting",
      framePreview: "Home frame preview",
      permission: "authority management",
    },
  },

  // 机构管理
  org: {
    country: "country",
    batch: "Batch configuration",
    orgName: "institution name  ",
    tag: "label",
    apps: "Application module",
    manage: "management",
    module: "Application module",
    address: "access address",
    optionalCX: "Optional app",
    selectedCX: "Selected  application",
    CX: "Application",
    store: "Book city configuration",
    channel: "Channel",
    frame: "frame",
    banner: "Carousel map",
    library: "Special library",
    optionallibrary: "可选专题书库",
    selectedlibrary: "已选专题书库",
    area: "area",
    deviceCount: "Number of devices (sets)",
    usersInfo: "Device user information",
    otherInfo: "other information",
    newOrg: "New institution",
    updateOrg: "Update institution",
    selectArea: "Select region",
    orgId: "Institutional coding",
    orgAddress: "Institution address",
    fliqlo: "Switch screen saver configuration",
    fliqloTip:
      "(can be changed by switching machine screen saver configuration)",
    powerOff: "Shutdown animation",
    powerOn: "Boot animation",
    standby: "Standby screen saver",
    storeChannel: "Book City Channel",
    storeFrame: "Book city frame",
    storeBanner: "Book city carousel",
    newDevice: "Add device",
    exportUsers: "Export user information",
    macAddress: "Device MAC address",
    userAccount: "Login user account",
    userName: "Login user name",
    userRole: "Login user role",
    updated_at: "last login time",
    addOrg: "Add institution",
    exportTag: "Export tag information",
    orgTag: "Institution label",
    addTag: "Add tag",
    tagName: "Label name",
    orgCount: "Number of institutions",
    sync: "同步信息",
    exportDevice: "导出设备信息",
    importDevice: "导入设备",
  },

  // 用户管理
  user: {
    giftCode: "Gift card",
    username: "username",
    userName: "Login name / username/ userID",
    addUser: "New users",
    name: "log-in name",
    id: "userID",
    nickname: "nickname",
    nicknameOld: "old nickname",
    email: "Email",
    role: "Role",
    selectRole: "Select a role",
    addRole: "New role",
    optionalPermission: "Optional permission",
    selectedPermission: "Selected permission",
    roleName: "character name",
    permission: "authority management",
    moduleName: "Module name",
    moduleNamePlaceholder: "Must match sidebar meta.key, e.g. Operations, Sales",
    moduleSearchPlaceholder: "Search module name",
    moduleNameRequired: "Please enter module name",
    moduleNameMin: "At least 2 characters",
    moduleTotal: "Total modules",
    moduleHint: "Module name must match route meta.key; assign in Role permissions.",
    addModule: "Add module",
    editModule: "Edit module",
    moduleDeleteConfirm: "Role permissions using this module will be removed. Continue?",
    macAddress: "Device address",
    unbind: "Untied",
    resetPsw: "重置密码",
    lockStatus: "Unlocked state",
    model: "model",
    unlock: "Unlock",
    users: "User Management",
    password: "Password",
    phone: "cellphone number",
    remark: "Remarks",
    selectOrg: "选择机构",
    select: "点击选择",
    lock: "锁定",
    storageLimit: "云盘容量",
    mac: "mac",
  },

  // 固件升级管理
  firmware: {
    updateFirmware: "Update firmware",
    addFirmware: "Add firmware",
    model: "model",
    brand: "Brand",
    versions: "version",
    type: "Types",
    lang: "Language",
    scrnW: "Screen width",
    scrnH: "Screen height",
    fingerprint: "Fingerprint information",
    upgrade: "upgraded version",
    downLoad: "download link",
    changeMsg: "Change information",
    time: "time",
    MAC: "Device MAC address",
    MACTip: "Enter a different MAC address, please enter the line feed",
  },

  // 销售相关
  sale: {
    coupon: {
      title1: "优惠券",
      details: "优惠券详情",
      activity: "活动名称",
      type: "类型",
      publishAt: "发布时间",
      endAt: "到期时间",
      gets: "领取",
      minus: "额度",
      discount: "折扣",
      num: "数量",
      useRange: "选择范围",
      valid: "有效期",
      userList: "目标账号",
      discountCoupon: "折扣卷",
      deduction: "抵扣卷",
      all: "全部",
      monthly: "月度",
      quarter: "季度",
      year: "年度",
      yuan: "元",
      zhe: "折",
      title2: "新增优惠券",
      inputPublishAt: "请输入发布时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入到期时间",
      inputMinus: "请输入优惠数值",
      inputNum: "请输入数值",
      inputActivity: "请输入活动名称",
      tips1: "单位：毛",
      tips2: "范围 0 ～ 1",
      tips3: "优惠券生成成功！",
      tips4: "目标账号数已超出！",
      verify1: "请输入折扣数值",
      verify2: "折扣数值不能大于1",
      verify3: "折扣数值不能小于0",
      verify4: "请输入数值",
      verify5: "请输入正整数",
    },
    orders: {
      title: "订单",
      userPin: "用户pin",
      des: "描述",
      vip_type: "vip类型",
      fee_type: "支付方式",
      pay_time: "支付时间",
      total: "总金融额",
      status: "支付状态",
      out_trade_no: "流水号",
    },
    gift: {
      name: "名称",
      title: "卡片管理",
      title1: "新增礼品卡",
      theme: "活动主题",
      type: "类型",
      giftCard: "礼品卡",
      commodityCard: "商品卡",
      validity: "有效期",
      price: "价格",
      startAt: "开始时间",
      endAt: "结束时间",
      activityTime: "活动时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入结束时间",
      num: "发行数量",
      gets: "领取数量",
      mac: "MAC（选填）",
      handle: "操作历史",
      verify1: "不能为空",
      verify2: "不能小于等于0",
      verify3: "只能输入数字",
      liveAt: "有效期",
      cardCount: "总量",
      cardOutCount: "已派发",
      cardResCount: "剩余",
      importCard: "请导入礼品卡",
    },
    card: {
      name: "名称",
      title: "卡片管理",
      title1: "新增礼品卡",
      theme: "活动主题",
      type: "类型",
      giftCard: "礼品卡",
      commodityCard: "商品卡",
      validity: "有效期",
      price: "价格",
      startAt: "开始时间",
      endAt: "结束时间",
      activityTime: "活动时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入结束时间",
      num: "发行数量",
      gets: "领取数量",
      mac: "MAC（选填）",
      handle: "操作历史",
      verify1: "不能为空",
      verify2: "不能小于等于0",
      verify3: "只能输入数字",
      liveAt: "有效期",
      cardCount: "总量",
      cardOutCount: "已派发",
      cardResCount: "剩余",
      importCard: "请导入礼品卡",
      inputCode: "请输入卡号",
      import: "导入",
      success: "成功",
      fail: "失败",
      item: "",
    },
  },

  // 设备管理
  devices: {
    poetry: {
      name: "标题",
      title: "诗词管理",
      title1: "新增诗词库",
      theme: "活动主题",
      type: "类型",
      giftCard: "礼品卡",
      commodityCard: "商品卡",
      validity: "有效期",
      price: "价格",
      startAt: "开始时间",
      endAt: "结束时间",
      activityTime: "活动时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入结束时间",
      num: "数量",
      mac: "MAC（选填）",
      handle: "操作历史",
      verify1: "不能为空",
      verify2: "不能小于等于0",
      verify3: "只能输入数字",
      liveAt: "有效期",
      cardCount: "总量",
      cardOutCount: "已派发",
      cardResCount: "剩余",
      importCard: "请导入礼品卡",
      inputCode: "请输入卡号",
      import: "导入",
      success: "成功",
      fail: "失败",
      item: "个",

      author: "作者",
      lang: "语言",
      publishStatus: "发布状态",
      inputTitle: "请输入标题",
      inputContent: "请输入内容",
    },
    dictionary: {
      name: "标题",
      title: "单词字典",
      title1: "新增单词分类",
      title2: "新增单词",
      theme: "活动主题",
      type: "类型",
      giftCard: "礼品卡",
      commodityCard: "商品卡",
      validity: "有效期",
      price: "价格",
      startAt: "开始时间",
      endAt: "结束时间",
      activityTime: "活动时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入结束时间",
      num: "数量",
      mac: "MAC（选填）",
      handle: "操作历史",
      verify1: "不能为空",
      verify2: "不能小于等于0",
      verify3: "只能输入数字",
      liveAt: "有效期",
      cardCount: "总量",
      cardOutCount: "已派发",
      cardResCount: "剩余",
      importCard: "请导入礼品卡",
      inputCode: "请输入卡号",
      import: "导入",
      success: "成功",
      fail: "失败",
      item: "个",

      author: "作者",
      lang: "语言",
      publishStatus: "发布状态",
      inputTitle: "请输入标题",
      inputContent: "请输入内容",

      word: "单词",
      phonetic: "音标",
      translations: "翻译",
      inputWord: "请输入单词",
    },

    motto: {
      name: "标题",
      title: "格言管理",
      title1: "新增格言分类",
      title2: "新增格言",
      theme: "活动主题",
      type: "类型",
      giftCard: "礼品卡",
      commodityCard: "商品卡",
      validity: "有效期",
      price: "价格",
      startAt: "开始时间",
      endAt: "结束时间",
      activityTime: "活动时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入结束时间",
      num: "数量",
      mac: "MAC（选填）",
      handle: "操作历史",
      verify1: "不能为空",
      verify2: "不能小于等于0",
      verify3: "只能输入数字",
      liveAt: "有效期",
      cardCount: "总量",
      cardOutCount: "已派发",
      cardResCount: "剩余",
      importCard: "请导入礼品卡",
      inputCode: "请输入卡号",
      import: "导入",
      success: "成功",
      fail: "失败",
      item: "个",

      author: "作者",
      lang: "语言",
      publishStatus: "发布状态",
      inputTitle: "请输入标题",
      inputContent: "请输入内容",

      motto: "格言",
      phonetic: "音标",
      translations: "翻译",
      inputMotto: "请输入格言",
    },
    power: {
      title: "标题",
    },
    staticBook: {
      title: "预装书",
    },
  },

  boox: {
    title1: "软件更新",
    title2: "标题",
    title3: "发布记录",
    title4: "APK管理",
    type: "类型",
    version: "版本",
    inputVersion: "请输入版本号",
    lang: "语言",
    description: "简介",
    introduce: "介绍",
    comment: "备注",
    file: "文件",
    region: "区域",
  },

  update: {
    category: "类别",
    title: "标题",
    type: "类型",
    version: "版本",
    lang: "语言",
    description: "简介",
    introduce: "介绍",
    comment: "备注",
    file: "文件",
    region: "区域",
    inputTitle: "请输入标题",
  },

  server: {
    name: "名字(默认显示)",
    host: "域名",
    ossConfig: "oss配置",
    lang: "语言",
    langGroup: "多语言",
    region: "区域",
    inputLang: "请输入语言",
    inputName: "请输入名字",
    inputRegion: "请输入区域",
    errDomain: "域名格式不正确",
  },

  // starNote Academy
  college: {
    title: "starNote Academy",
    generalSettings: "General Settings",
    dataCenterSettings: "Data Center Homepage Configuration",
    materialCenterSettings: "Material Center Homepage Configuration",
    library: "Data Library",
    libraryMgmt: "Data Library Management",
    libraryCategoryMgmt: "Data Library Category Management",
    templateLibrary: "Template Library",
    stickerLibrary: "Sticker Library",
    promotionCode: "Promotion Code",
    tagMgmt: "Tag Management",
    publisherMgmt: "Publisher Management",
    addPrimaryCategory: "Add Primary Category",
    addData: "Add Material",
    primaryCategory: "Primary Category",
    secondaryCategory: "Secondary Category",
    tertiaryCategory: "Tertiary Category",
    loading: "Loading~",
    allDataLoaded: "All data has been loaded~",
    pleaseSelectCategory: "Please select a category",
    deleteCategoryConfirm: "After deletion, all content and categories will not be displayed. Are you sure you want to delete?",
    removeDataConfirm: "After removing the content, it will not be displayed under this category. Are you sure you want to remove?",
    codeGeneration: "Promotion Code Generation",
    codeLibrary: "Promotion Code Library",
    generateCode: "Generate Promotion Code",
    editCode: "Edit Promotion Code",
    deleteCodeConfirm: "Are you sure you want to delete the content?",
    inputCategoryNameZh: "Please enter simplified Chinese category name",
    inputCategoryNameTw: "Please enter traditional Chinese category name",
    inputCategoryNameEn: "Please enter English category name",
    categoryNameHint: "(within xx characters)",
    addCategory: "Add Category",
    editCategory: "Edit Category",
    deleteCategory: "Delete Category",
    addSubCategory: "Add Sub Category",
    editSubCategory: "Edit Sub Category",
    deleteSubCategory: "Delete Sub Category",
  },
};
